import React from 'react'
import styled from 'styled-components'
import { useDispatch } from 'react-redux'
import classnames from 'classnames'
import { loadFont } from 'loankeeper-common/helpers/styles'
import { LKButton as LKBaseButton } from 'loankeeper-common/components'
import { usePermissions } from './containers/withConstantPermissions'
import LKModal, { actions as LKModalActions } from './LKModal'

type LKButtonParams = {
  onClick: Function
  className: string
  permission: string
  confirmation: any
  [key: string]: any
}

const LKButton = (props) => <LKBaseButton {...props} className={props.className} />

const LKButtonConfirmation = ({ className, confirmation, onClick, permission, ...rest }: Partial<LKButtonParams>) => {
  const dispatch = useDispatch()

  const permissions = usePermissions()

  function handleClick(event) {
    if (confirmation) {
      dispatch(LKModalActions.openConfirmation(confirmation))
    } else if (onClick) {
      onClick(event)
    }
  }

  function handleConfirm() {
    if (onClick) {
      onClick()
    }
  }

  if (permission && !permissions[permission]) {
    return null
  }

  return (
    <>
      {/** @ts-ignore */}
      {confirmation && <LKModal.Confirmation name={confirmation} onConfirm={handleConfirm} />}
      <LKBaseButton onClick={handleClick} {...rest} className={classnames('lk-icon-button', className)} />
    </>
  )
}

const StyledSubmitButton = styled(LKButton)`
  &.ui.button {
    height: 33px;
    padding: 5px 15px;

    .lk-icon {
      width: 20px;
      height: 15px;
    }

    .lk-button-content {
      ${(props) => loadFont(props.theme.buttonFont)};
    }
  }
`

export const SubmitButton = ({ children, ...rest }) => (
  <StyledSubmitButton {...rest} type="primary" alias="binoculars" isSubmit>
    {children}
  </StyledSubmitButton>
)

export { LKButton }

export default LKButtonConfirmation
